module.exports = __webpack_public_path__ + "b2cf30e7702e0f136dda3549c01b968f.svg";